import styled from "styled-components";
import { isMobile } from "../../utils";
import variables from "./variables";

export const DashboardMainContainer = styled.section`
  .MuiInputBase-root {
    border-radius: 8px;
    background: ${variables.grey100};
    height: 3rem;
    .MuiSelect-outlined.MuiSelect-outlined {
      min-height: unset;
      padding: 18px;
    }
  }
  .MuiInputLabel-outlined {
    transform: translate(14px, 16px) scale(1);
  }
  .MuiFormLabel-root.Mui-focused {
    color: ${variables.grey800};
  }
  .MuiCheckbox-colorPrimary.Mui-checked {
    color: ${variables.primaryColor};
  }
  .MuiAutocomplete-root {
    padding-right: 10px;
    margin-bottom: 30px;
  }
  #sushi-textarea textarea:focus {
    border: 1px solid ${variables.grey500};
  }
  #sushi-textarea label {
    color: ${variables.grey600};
  }
  .sushi-shimmer {
    background-color: ${variables.grey200} !important;
    border-radius: 8px;
    background-image: linear-gradient(
      to right,
      ${variables.grey50} 0%,
      ${variables.grey100} 10%,
      ${variables.grey50} 40%,
      ${variables.grey50} 100%
    ) !important;
  }
`;

export const ViewContainer = styled.section`
  height: calc(100vh - 100px);
  width: 100%;
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: ${(props) => (props.align ? props.align : "center")};
  justify-content: ${(props) =>
    props.justify ? props.justify : "space-between"};
`;

export const Heading = styled.div`
  color: ${variables.primaryTextColor};
  font-size: 24px !important;
  margin: unset;
  font-weight: 500;
`;

export const BottomSectionModal = styled.div`
  border-top: 1px solid ${variables.grey200};
  padding-top: 20px;
  margin-top: 20px;
  opacity: ${({ permissions }) =>
    permissions != undefined ? (permissions ? "1" : "0.6") : "1"};
  pointer-events: ${({ permissions }) =>
    permissions != undefined ? (permissions ? "all" : "none") : "all"};
`;

export const BorderBox = styled.div`
  border: 1px solid ${variables.grey200};
  padding: 1.25rem 0.625rem 0 1.25rem;
  border-radius: 0.5rem;
  margin-bottom: 1.25rem;
  display: ${(props) => (props.display ? props.display : "block")};
  align-items: ${(props) => (props.align ? props.align : "center")};
  justify-content: ${(props) =>
    props.justify ? props.justify : "space-between"};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "all")};
`;

export const Link = styled.a`
  color: ${variables.primaryColor};
  cursor: pointer;
`;

export const HorizontalTabs = styled(FlexContainer)`
  background: ${variables.grey50};
  border: 0.5px solid ${variables.grey400};
  border-radius: 8px;
`;

HorizontalTabs.Link = styled.div`
  padding: 8px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  width: 50%;
  text-align: center;
  background: ${({ active }) =>
    active ? variables.grey900 : variables.grey50};
  color: ${({ active }) => (active ? variables.white : variables.grey700)};
`;

export const UploadCsvOption = styled.div`
  background: ${variables.grey50};
  border: 1px solid ${variables.grey200};
  box-sizing: border-box;
  border-radius: 8px;
  padding: 1rem;
  width: 100%;
`;

export const NotesSection = styled.div`
  padding: 1.5rem 0;
  li {
    font-size: 0.9rem;
    color: ${variables.grey700};
    margin-bottom: 0.5rem;
  }
`;

export const Pill = styled.span`
  background: ${({ isFalse }) =>
    isFalse ? variables.pink50 : variables.teal50};
  border: 1px solid
    ${({ isFalse }) => (isFalse ? variables.pink400 : variables.teal400)};
  color: ${({ isFalse }) =>
    isFalse ? variables.pink600 : variables.teal600} !important;
  box-sizing: border-box;
  border-radius: 3px;
  padding: 2px 4px;
  text-align: center;
  word-break: initial;
`;

export const FileUploadSuccessBar = styled.div`
  background: ${variables.green300};
  border-radius: 0.5rem;
  box-sizing: border-box;
  padding: 0.5rem;
  margin-bottom: 1rem;
`;

export const DeleteBar = styled(FlexContainer)`
  cursor: pointer;
  span {
    color: ${variables.red500};
  }
`;

export const Divider = styled.div`
  height: ${({ height = "1px" }) => height};
  background-color: ${({ color = variables.grey300 }) => color};
  width: ${({ width = "100%" }) => width};
`;

export const BorderedBox = styled.div`
  background: ${variables.white};
  border: 1px solid ${variables.grey200};
  border-radius: 8px;
  padding: ${({ padding = "30px" }) => padding};
  cursor: ${({ cursor = "" }) => cursor};
`;

export const FieldsContainer = styled.div`
  box-sizing: border-box;
  border-radius: 0.5rem;
  border: ${({ border }) =>
    border ? `1px solid ${variables.grey300}` : "none"};
  background: ${variables.white};
  padding: ${({ noPadding }) =>
    noPadding ? "0" : isMobile() ? "0 0.2rem" : "0 1.5rem"};
  margin-bottom: 2.5rem;
  max-height: 50vh;
  overflow: scroll;
`;

export const FieldsSection = styled.div`
  & > p {
    letter-spacing: 0.18rem;
    color: ${variables.grey600};
    margin-bottom: ${({ marginBottom }) =>
      marginBottom ? marginBottom : "0.75rem"};
  }
`;
